import React, { useRef, useState } from 'react';
import { Breadcrumbs, Button, IconButton, InputBase, Paper, Stack, Typography, Menu, MenuItem } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Search, Upload, Add, FilterList, UploadOutlined, Opacity } from '@mui/icons-material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Bulkupload, Export, Filter } from '../../Svg';

// Styled components
const SearchInput = styled(Paper)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  borderRadius: '8px',
  boxShadow: 'none',
  border: `1px solid ${theme.palette.divider}`,
  width: '320px',
  fontFamily: `'Public Sans', sans-serif`,
}));

const ActionButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  marginRight: theme.spacing(1),
  fontSize: '0.875rem',
  color: '#512DA8',
  backgroundColor: '#F0F1F3',
  fontSize: '14px',
  fontWeight: '600 !important',
  fontFamily: `'Public Sans', sans-serif`,
  '&:hover': {
    backgroundColor: theme.palette.grey[200],
  },
}));

const AddCategoryButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  fontSize: '0.875rem',
  backgroundColor: '#512DA8',
  color: '#fff',
  fontFamily: `'Public Sans', sans-serif`,
  '&:hover': {
    backgroundColor: '#512DA8',
    opacity:'0.65',
  },
}));

// `actions`: optional extra controls rendered to the left of "Back to list"
const NestedUserHeader = ({ root, index,onClickadd,buttonText,show, actions}) => {

  const navigate = useNavigate()
  

  return (
    <>
      <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2} marginBottom={2}>
        {/* Breadcrumbs and Title */}
        <Stack spacing={1}>
          <Typography
            sx={{
              color: 'rgba(29, 31, 44, 1)',
              fontSize: '24px',
              fontWeight: '600',
              fontFamily: `'Public Sans', sans-serif`,
            }}>
            {index}
          </Typography>
          <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
            <Typography color="text.secondary"
              sx={{
                fontSize: '14px',
                fontFamily: `'Public Sans', sans-serif`,
              }}>{root}
            </Typography>
            <Typography color="text.primary"
              sx={{
                fontSize: '14px',
                fontFamily: `'Public Sans', sans-serif`,
              }}> {index}
            </Typography>
          </Breadcrumbs>
        </Stack>

        <Stack direction="row" alignItems="center" spacing={2} flexWrap="wrap" useFlexGap>
          {actions}
          <ActionButton onClick={()=>navigate(-1)}>Back to list</ActionButton>
          { show &&
                  <AddCategoryButton  onClick={onClickadd}>{buttonText}</AddCategoryButton>
          }
        </Stack>
        
      </Stack>
    </>
  );
};

export default NestedUserHeader;
